import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  required,
  ArrayInput,
  SimpleFormIterator,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';

export const PrivacySectionCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput
        source="subtitle"
        validate={[required()]}
        fullWidth
      />
      <RichTextInput
        source="description"
        validate={[required()]}
        fullWidth
      />
      <ArrayInput source="items" label="Пункты политики">
        <SimpleFormIterator inline>
          <TextInput
            source="title"
            validate={[required()]}
            label="Заголовок пункта"
            fullWidth
          />
          <RichTextInput
            source="description"
            validate={[required()]}
            label="Описание пункта"
            fullWidth
          />
        </SimpleFormIterator>
      </ArrayInput>
      <NumberInput
        source="sortOrder"
        defaultValue={0}
        min={0}
      />
      <BooleanInput
        source="isActive"
        defaultValue={true}
      />
    </SimpleForm>
  </Create>
);
